const Helpers = (function () {
  let helperFunctions = {}

  helperFunctions.capitalize = (string) => {
    return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();
  };

  return helperFunctions;
})();

export { Helpers };
